import {RootState} from '@/store'
import {ActionTree} from 'vuex'

export const actions: ActionTree<RootState, RootState> = {

    resetStore: ({commit}: any) => {
        commit('authorization/resetState')
        commit('lobby/resetState')
        commit('members/resetState')
        commit('search/resetState')
        commit('documents/resetState')
        commit('credit/resetState')
        commit('loans/resetState')
        commit('loanConfiguration/resetState')
        commit('archiveDocumentsOpener/resetState')
    }
}